import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { EFCategory } from '../efCategory.model';
import { EfcategoryService } from '../efcategory.service';

@Component({
  selector: 'app-category-form',
  templateUrl: './category-form.component.html',
  styleUrls: ['./category-form.component.css']
})
export class CategoryFormComponent implements OnInit {

  category: EFCategory = {} as EFCategory;
  updateMode = false;
  imagPath: any;
  files = [];
  active = true;
  spinnerOverlay = false;
  lang: any;

  constructor(private router: Router,
    private service: EfcategoryService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private translate: TranslateService,
    private localStorage: LocalStorageService) { }

  ngOnInit(): void {

    this.imagPath = this.globle.imgPath;
    this.lang = this.localStorage.retrieve("lang");
    this.getUrlParam();
  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.category.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.spinnerOverlay = true;
    this.service.getById(this.category.id).subscribe(data => {
      this.category = data
      this.spinnerOverlay = false;
      this.category.status == 1 ? this.active = true : this.active = false;

    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  back() {
    this.router.navigate(["./master/efawateercome/efcategoriesList"]);
  }

  submit() {
    this.spinnerOverlay = true;
    this.active ? this.category.status = 1 : this.category.status = 0;

    this.update();

    // if (this.files.length > 0) {
    //   this.uploadImage();
    // }
    // else {
    //   !this.updateMode ? this.create() : this.update();
    // }
  }

  update() {
    this.service.Update(this.category).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

      })
  }

  onSelectImage(files: any) {
    this.files = files.target.files;
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }


}
